module.exports = __webpack_public_path__ + "static/media/destination_image_4.e6acf91e.webp";